import { render } from "./User_profil.vue?vue&type=template&id=f8017fce&scoped=true"
import script from "./User_profil.vue?vue&type=script&lang=js"
export * from "./User_profil.vue?vue&type=script&lang=js"

import "./User_profil.vue?vue&type=style&index=0&id=f8017fce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8017fce"]])

export default __exports__